import { render, staticRenderFns } from "./edit_base.vue?vue&type=template&id=0abbbb5a&scoped=true&"
import script from "./edit_base.vue?vue&type=script&lang=js&"
export * from "./edit_base.vue?vue&type=script&lang=js&"
import style0 from "./edit_base.vue?vue&type=style&index=0&id=0abbbb5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abbbb5a",
  null
  
)

export default component.exports